<template>
  <div class="RegistrazioneModulo" :class="{ 'mobile': isMobile() }">
    <h1>{{ $t('register.label.title') }}</h1>

    <el-collapse v-model="activeName" @change="changeTab">
      <el-collapse-item name="1">
        <template slot="title">
          <div @click="cambio('1')">
            <div class="icon" :class="{ 'is-correct': validateStep1 }">
              <span v-if="!validateStep1">1</span>
              <icon v-else name="riv-tick" scale="1"></icon>
            </div>
            <span class="des">{{ $t('register.label.profile') }}</span>
          </div>
        </template>
        <div class="">
          <el-form :model="step1Form" :rules="rulesStep1" ref="step1Form" class="" :show-message=false>
            <el-form-item prop="username">
              <el-input v-model="step1Form.username" v-bind:placeholder="$t('register.label.username')"></el-input>
            </el-form-item>
            <el-form-item prop="cpa">
              <el-input v-model="step1Form.cpa" v-bind:placeholder="$t('register.label.cpa')"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button @click="verifyCPA('step1Form', 1)">{{ $t('register.btn.next') }}</el-button>
            </el-form-item>

          </el-form>
        </div>
      </el-collapse-item>
      <el-collapse-item title="Feedback" name="2">
        <template slot="title">
          <div @click="cambio('2')">
            <div class="icon" :class="{ 'is-correct': validateStep2 }">
              <span v-if="!validateStep2">2</span>
              <icon v-else name="riv-tick" scale="1"></icon>
            </div>
            <span class="des">{{ $t('register.label.security') }}</span>
          </div>
        </template>
        <div class="">
          <el-form :model="step2Form" :rules="rulesStep2" ref="step2Form" class="" :show-message=false>
            <el-form-item prop="pwd">
              <el-input v-model="step2Form.pwd" v-bind:placeholder="$t('register.label.pwd')"
                type="password"></el-input>
            </el-form-item>
            <el-form-item prop="pwdRepeat">
              <el-input v-model="step2Form.pwdRepeat" v-bind:placeholder="$t('register.label.pwdRepeat')"
                type="password"></el-input>
            </el-form-item>
            <el-form-item prop="rqsQstn">
              <el-select v-model="step2Form.rqsQstn" v-bind:placeholder="$t('register.label.rqsQstn')">
                <el-option v-for="item in secretQuestions" :key="item.value" :label="$t('questions.' + item.value)"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="ansQstn">
              <el-input v-model="step2Form.ansQstn" v-bind:placeholder="$t('register.label.ansQstn')"></el-input>
            </el-form-item>
            <el-form-item prop="ansQstnRepeat">
              <el-input v-model="step2Form.ansQstnRepeat"
                v-bind:placeholder="$t('register.label.ansQstnRepeat')"></el-input>
            </el-form-item>
            <el-form-item prop="mail">
              <el-input v-model="step2Form.mail" v-bind:placeholder="$t('register.label.mail')"></el-input>
            </el-form-item>
            <el-form-item>
              <span class="my-label">{{ $t('register.label.pwdExpiry') }}</span>
              <el-radio-group v-model="step2Form.pwdExpiry">
                <el-radio :label="'SI'">{{ $t('register.label.yes') }}</el-radio>
                <el-radio :label="'NO'">{{ $t('register.label.no') }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item>
              <el-button @click="submitForm('step2Form')">{{ $t('register.btn.register') }}</el-button>
            </el-form-item>

          </el-form>
        </div>
      </el-collapse-item>
    </el-collapse>

  </div>
</template>

<script>
export default {
  name: 'Register',
  props: ['language'],
  i18n: {
    messages: {
      it_IT: {
        register: {
          label: {
            title: 'Registrazione',
            profile: 'Profilo',
            security: 'Sicurezza',
            username: 'Username *',
            password: 'Password *',
            cpa: 'CPA *',
            pwd: 'Password *',
            pwdRepeat: 'Ripeti Password *',
            rqsQstn: 'Domanda Segreta *',
            ansQstn: 'Risposta Segreta *',
            ansQstnRepeat: 'Conferma Risposta Segreta *',
            mail: 'Indirizzo E-mail *',
            pwdExpiry: 'Rinuncia Scadenza Password',
            yes: 'Si',
            no: 'No'
          },
          btn: {
            next: 'Avanti',
            register: 'Registrati'
          },
          msg: {
            1903: 'Request parameter error',
            1904: 'Formato della mail non valido',
            1906: 'Le password inserite non corrispondono',
            confirm: 'Utente Registrato correttamente'
          }
        }
      },
      en_GB: {
        register: {
          label: {
            title: 'Registrazione',
            profile: 'Profilo',
            security: 'Sicurezza',
            username: 'Username *',
            password: 'Password *',
            cpa: 'Password *',
            pwd: 'Password *',
            pwdRepeat: 'Ripeti Password *',
            rqsQstn: 'Domanda Segreta *',
            ansQstn: 'Risposta Segreta *',
            ansQstnRepeat: 'Conferma Risposta Segreta *',
            mail: 'Indirizzo E-mail *',
            pwdExpiry: 'Rinuncia Scadenza Password',
            yes: 'Si',
            no: 'No'
          },
          btn: {
            next: 'Next',
            register: 'Register'
          },
          msg: {
            1903: 'Request parameter error',
            1904: 'Invalid email format',
            1906: 'Entered passwords don\'t match',
            confirm: 'User duly registered'
          }
        }
      },
      es_ES: {
        register: {
          label: {
            title: 'Registro',
            profile: 'Perfil',
            security: 'Seguridad',
            username: 'Usuario *',
            password: 'Contraseña *',
            cpa: 'Contraseña *',
            pwd: 'Contraseña *',
            pwdRepeat: 'Confirmar contraseña *',
            rqsQstn: 'Question de sécurité *',
            ansQstn: 'Réponse secrète *',
            ansQstnRepeat: 'Confirmar Réponse secrète *',
            mail: ' Dirección email *',
            pwdExpiry: 'Renunciar a la caducidad de la contraseña',
            yes: 'Si',
            no: 'No'
          },
          btn: {
            next: 'Adelante',
            register: 'Registro'
          },
          msg: {
            1903: 'Request parameter error',
            1904: 'Formato de correo electrónico no válido',
            1906: 'Las contraseñas no coinciden',
            confirm: 'Usuario registrado correctamente'
          }
        }
      },
      fr_FR: {
        register: {
          label: {
            title: 'Inscription',
            profile: 'Profil',
            security: 'Sécurité',
            username: 'Identifiant *',
            password: 'Mot de passe *',
            cpa: 'Mot de passe *',
            pwd: 'Nouveau mot de passe *',
            pwdRepeat: 'Répéter le nouveau mot de passe *',
            rqsQstn: 'Question secrète *',
            ansQstn: 'Réponse secrète *',
            ansQstnRepeat: 'Confirmer la Réponse secrète *',
            mail: 'Adresse e-mail *',
            pwdExpiry: 'Renoncer à l\'échéance du mot de passe',
            yes: 'Oui',
            no: 'Non'
          },
          btn: {
            next: 'Avancer',
            register: 'Registrierung abschließen'
          },
          msg: {
            1903: 'Request parameter error',
            1904: 'Format de courrier électronique non valide',
            1906: 'Les mots de passe saisis ne sont pas valables',
            confirm: 'Enregistrement de l\'utilisateur effectué'
          }
        }
      },
      de_DE: {
        register: {
          label: {
            title: 'Registrierung',
            profile: 'Profil',
            security: 'Sicherheit',
            username: 'Benutzer *',
            password: 'Password *',
            cpa: 'Initialisierungs-Passwort *',
            pwd: 'Passwort *',
            pwdRepeat: 'Passwort wiederholen *',
            rqsQstn: 'Geheime Frage *',
            ansQstn: 'Geheime Antwort *',
            ansQstnRepeat: 'Geheime Antwort wiederholen *',
            mail: 'E-Mail *',
            pwdExpiry: 'Unbegrenzte Gültigkeit des Passworts gewünscht?',
            yes: 'Ja',
            no: 'Nein'
          },
          btn: {
            next: 'Weiter',
            register: 'Registrierung abschließen'
          },
          msg: {
            1903: 'Request parameter error',
            1904: 'Ungültiges E-Mail-Format',
            1906: 'Eingegebene Passwörter stimmen nicht',
            confirm: 'Benutzer korrekt registriert'
          }
        }
      }
    }
  },
  data() {
    var validatePwdRepeat = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please input the password again'))
      } else if (value !== this.step2Form.pwd) {
        callback(new Error('Two inputs don\'t match!'))
      } else {
        callback()
      }
    }
    return {
      country: process.env.country,
      activeName: ['1'],
      currentActiveName: '1',
      validateStep1: false,
      validateStep2: false,
      step1Form: {
        username: '',
        cpa: ''
      },
      step2Form: {
        pwd: '',
        pwdRepeat: '',
        rqsQstn: '',
        ansQstn: '',
        ansQstnRepeat: '',
        mail: '',
        pwdExpiry: 'NO'
      },
      rulesStep1: {
        username: [
          { required: true, trigger: 'blur' }
        ],
        cpa: [
          { required: true, trigger: 'blur' }
        ]
      },
      rulesStep2: {
        pwd: [
          { required: true, trigger: 'blur' }
        ],
        pwdRepeat: [
          { validator: validatePwdRepeat, trigger: 'blur' }
        ],
        rqsQstn: [
          { required: true, trigger: 'change' }
        ],
        ansQstn: [
          { required: true, trigger: 'blur' }
        ],
        ansQstnRepeat: [
          { required: true, trigger: 'blur' }
        ],
        mail: [
          { required: true, trigger: 'blur' }
        ]
      },
      secretQuestions: [{
        value: 'q1'
      }, {
        value: 'q2'
      }, {
        value: 'q3'
      }, {
        value: 'q4'
      }, {
        value: 'q5'
      }, {
        value: 'q6'
      }, {
        value: 'q7'
      }, {
        value: 'q8'
      }]
    }
  },
  beforeMount: function () {
  },
  methods: {
    verifyCPA: function (formName, step) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let obj = {
            params: {
              username: this.step1Form.username.trim(),
              cpa: this.step1Form.cpa.trim()
            }
          }
          this.$http.get('noauth/verifyCPA', obj).then(response => {
            if (response.body.rc === 0) {
              this.validateStep1 = true
              this.activeName = ['2']
              this.currentActiveName = '2'
            } else {
              this.validateStep1 = false
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
            }
          }, response => {
            //this.validateStep1 = false
            this.$message({
              showClose: true,
              message: response.status + '(' + response.statusText + ')',
              type: 'error',
              duration: process.env.duration
            })
          })
        } else {
          this.validateStep1 = false
        }
      })
    },
    cambio: function (val) {
      this.activeName = []
      if (val === '1') {
        this.currentActiveName = '1'
      } else if (val === '2' && this.validateStep1) {
        this.currentActiveName = '2'
      }
    },
    changeTab: function () {
      this.activeName = [this.currentActiveName]
    },
    submitForm: function (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var obj = {
            language: this.language,
            username: this.step1Form.username,
            cpa: this.step1Form.cpa,
            mail: this.step2Form.mail,
            domanda: this.step2Form.rqsQstn,
            risposta: this.step2Form.ansQstn,
            password: this.step2Form.pwd,
            rinuncia: this.step2Form.pwdExpiry
          }
          this.$http.post('noauth/registration', obj).then(response => {
            if (response.body.rc === 0) {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'success',
                duration: process.env.duration
              })
              this.$router.push({ name: 'Login' })
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
              // var errCode = response.body.msg[0].msgId
              // this.$message.error(this.$i18n.messages[this.$root.$i18n.locale.toLocaleString()].register.msg[errCode])
            }
          }, response => {
            this.$message({
              showClose: true,
              message: response.status + ' (' + response.statusText + ')',
              type: 'error',
              duration: process.env.duration
            })
          })
        }
      })
    }

  }
}
</script>

<style lang="less">
@import "../../assets/less/general.less";

.RegistrazioneModulo {
  height: 630px;
  padding: 15px 15px;

  h1 {
    text-align: right;
    .set-font(@weight: 300, @size: 24px, @color: #fff);
    margin-bottom: 20px;
  }

  .info {
    .displayBlock {
      display: block;
    }

    span {
      .set-font(@weight: 700, @size: 12px, @color: #000);
    }

    a {
      text-align: center;

      img {
        width: 25px;
      }

      span {
        .set-font(@weight: 700, @size: 12px, @color: #666);
        text-decoration: underline;
      }
    }
  }

  .el-form {
    width: 290px;
  }

  .el-form-item {
    //text-align: left;
    margin-bottom: 0;

    .el-form-item__content {
      line-height: 35px;
    }

    &.is-error {
      .el-input__inner {
        outline: #f56c6c solid 1px;
        outline: rgba(255, 0, 0, 0.9) solid 1px;
        outline-offset: 0px;
      }
    }

    .el-select {
      width: 100%;
    }

    .el-input {
      width: 100%;

      .el-input__inner {
        .set-font(@weight: 300, @size: 14px, @color: #000);
        display: block;
        //margin: 10px auto;
        padding: 10px;
        max-width: 290px;
        border: 0;
        background-color: #fff;
        //background-color: rgba(255, 255, 255, .7);
        border: none;
        border-radius: 0px;
        // line-height: 0;
        height: 30px;

        &:focus {
          outline: #000 solid 1px;
          outline: rgba(0, 0, 0, .4) solid 1px;
          outline-offset: 0px;
        }
      }

      .el-input__prefix {
        display: none;
      }

      ::placeholder {
        .set-font(@weight: 300, @size: 14px, @color: #a2a2a2, @family: 'os-lightitalic');
      }
    }

    .el-button {
      width: 100%;
      .set-font(@weight: 300, @size: 14px, @color: #fff);
      background-color: #000;
      background-color: rgba(0, 0, 0, .6);
      font-weight: 300;
      transition: background-color .3s;
      border: 0;
      border-radius: 0;
      max-width: 290px;
      text-align: center;
      margin-top: 30px;

      &:hover {
        background-color: #000;
        background-color: rgba(0, 0, 0, .8);
        cursor: pointer;
      }

      &:focus {
        outline: 0
      }
    }

    .el-checkbox__label {
      color: #000;
    }

    .el-radio-group {
      width: 150px;

      .el-radio__label {
        color: #000000;
      }
    }

    .my-label {
      display: block;
      color: #000000;
    }
  }

  .errorLogin {
    .set-font(@weight: 300, @size: 14px, @color: #d20e0e);
    //display: block;
    height: 22px;
    text-align: center;
  }

  // Accordion
  .el-collapse {
    max-width: 350px;
    //text-align: center;
    margin-right: auto;
    margin-left: auto;
    border: none;

    div[role=tab] {
      height: 30px;
      margin-top: 6px;
      margin-bottom: 6px;

      div[role=button] {
        border: none;
        background-color: transparent;
        line-height: 24px;

        i {
          display: none;
        }

        .icon {
          float: left;
          background-color: #fff;
          width: 30px;
          height: 30px;
          border-radius: 50%;
          border: 2px solid;
          border-color: inherit;

          span {
            .set-font(@weight: 300, @size: 20px, @color: #000);
            padding-left: 7px;
          }

          .fa-icon {
            margin-top: 7px;
            margin-left: 0px;
          }

          &.is-correct {
            background-color: #000;
          }
        }

        .des {
          .set-font(@weight: 300, @size: 18px, @color: #fff);
          padding-left: 12px;
          padding-top: 1px;
        }
      }
    }

    div[role=tabpanel] {
      border: none;
      background-color: transparent;
      border-left: 1px solid #fff;
      margin-left: 12px;
      margin-bottom: 6px;
      margin-top: 6px;
      padding-left: 30px;
    }
  }

  .el-select {
    .el-input__suffix {
      top: -3px;

      .el-input__suffix-inner {
        position: absolute;
        right: 0px;
      }
    }
  }

  .riv-tick-c0 {
    fill: #fff;
  }

  &.mobile {
    h1 {
      text-align: left;
      .set-font(@weight: 900, @size: 24px, @color: #fff);
      margin-bottom: 40px;

      span {
        .set-font(@weight: 300, @size: 24px, @color: #fff);
      }
    }

    .el-input {
      width: 100%;

      .el-input__inner {
        height: 40px;
        margin: 5px auto;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Login/Registrazione.vue